<div class="auth-main">
	<div class="auth-wrapper v3">
		<div class="auth-form">
			<div class="card mt-5">
				<div class="card-body">
					<form #editUserFrm="ngForm" (ngSubmit)="forgotPassword()" [validate-form]="'forgotPassword'">
						<a href="javascript:" class="d-flex justify-content-center">
							@if (themeMode === false) {
								<img src="assets/images/vms-logo.png" width="100" alt="logo-img" />
							} @else {
								<img src="assets/images/logo-dark.png" width="100" alt="darkMode-logo" />
							}
						</a>
						<div class="row">
							<div class="d-flex justify-content-center">
								<div class="auth-header text-center">
									<h1 class="text-secondary mt-5"><b>{{"users.forgot_your_password" | translate}}</b></h1>
									<p class="f-16 mt-3"></p>
								</div>
							</div>
						</div>
						<p>{{"users.send_reset_password_link" | translate}}</p>
						<div class="form-floating mb-2">
							<input
								type="email"
								class="form-control"
								id="username"
								name="email"
								[(ngModel)]="forgot.email"
								[ngClass]="{ 'is-invalid': !elementValidationMapper['email'].isValid }"
								placeholder="name@example.com"
							/>
							<label for="username">
								{{ "users.email_address" | translate }}<b>*</b>
							</label>
						</div>
						<hr />
						<app-captcha #captchaComponent></app-captcha>
						<div class="d-grid mt-4">
							<button
								type="submit"
								[disabled]="!captchaComponent.captchaText || captchaComponent.triesLimitReached"
								class="btn btn-secondary p-2"
							>
								{{"g.submit" | translate}}
							</button>
						</div>
						<div class="d-grid mt-4">
							<button class="btn btn-light-secondary" (click)="goBack()">{{"g.cancel" | translate}}</button>
						</div>
						<hr />
					</form>
				</div>
			</div>
		</div>
	</div>
</div>
